import React, { useRef, useState } from 'react';
import { FloatingArrow, useClick, useDismiss, useFloating, useInteractions, arrow, offset } from '@floating-ui/react';
import { UIGameHelpCostsInformation } from './UIGameHelpCostsInformation/index.ts';
import { UIGameHelpVPInformation } from './UIGameHelpVPInformation/index.ts';
import styles from './UIGameHelpInformationButton.module.scss';
import { T } from '@colonist/ui';
import IconDownArrowBlack from '@static/images/icon_arrow_down_black.svg';
import clsx from 'clsx';
import IconInfo from '@static/images/icon_info.svg';
export const UIGameHelpInformationButton = ({ gameMode, isMechanicIslandExplorationActive, playerColor, victoryPointsToWin, className, isDismissibleByOutsideClick, onInfoWindowViewed, onInfoWindowClosed, onInfoWindowTabChanged })=>{
    const [isOpen, setIsOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('vp');
    const arrowRef = useRef(null);
    const handleOpenChange = (open)=>{
        setIsOpen(open);
        if (open) {
            onInfoWindowViewed === null || onInfoWindowViewed === void 0 ? void 0 : onInfoWindowViewed(activeTab);
            return;
        }
        onInfoWindowClosed === null || onInfoWindowClosed === void 0 ? void 0 : onInfoWindowClosed();
    };
    const { refs, floatingStyles, context } = useFloating({
        open: isOpen,
        onOpenChange: handleOpenChange,
        placement: 'bottom-start',
        middleware: [
            offset(12),
            arrow({
                element: arrowRef
            })
        ]
    });
    const click = useClick(context);
    const dismiss = useDismiss(context, {
        enabled: isDismissibleByOutsideClick
    });
    const { getReferenceProps, getFloatingProps } = useInteractions([
        click,
        dismiss
    ]);
    const handleSwitchTab = ()=>{
        const newTab = activeTab == 'vp' ? 'costs' : 'vp';
        onInfoWindowTabChanged === null || onInfoWindowTabChanged === void 0 ? void 0 : onInfoWindowTabChanged(newTab);
        setActiveTab(newTab);
    };
    const tabs = {
        vp: {
            component: /*#__PURE__*/ React.createElement(UIGameHelpVPInformation, {
                gameMode: gameMode,
                isMechanicIslandExplorationActive: isMechanicIslandExplorationActive,
                playerColor: playerColor,
                victoryPointsToWin: victoryPointsToWin
            }),
            title: {
                key: 'strings:game.endGame.icons.trophy'
            }
        },
        costs: {
            component: /*#__PURE__*/ React.createElement(UIGameHelpCostsInformation, {
                gameMode: gameMode,
                playerColor: playerColor
            }),
            title: {
                key: 'strings:game.buildCosts.title'
            }
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, className)
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.trigger,
        onClick: ()=>handleOpenChange(!isOpen),
        ref: refs.setReference,
        src: IconInfo,
        ...getReferenceProps()
    }), isOpen && /*#__PURE__*/ React.createElement("div", {
        ...getFloatingProps(),
        ref: refs.setFloating,
        style: floatingStyles
    }, /*#__PURE__*/ React.createElement(FloatingArrow, {
        className: styles.arrow,
        context: context,
        ref: arrowRef
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.dialogOverlay
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.header
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.heading
    }, /*#__PURE__*/ React.createElement(T, {
        id: tabs[activeTab].title
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.tabSwitcher
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.tabButton, styles.left),
        onClick: handleSwitchTab
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.icon,
        src: IconDownArrowBlack
    })), /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.tabButton, styles.right),
        onClick: handleSwitchTab
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.icon,
        src: IconDownArrowBlack
    })))), tabs[activeTab].component)));
};
